import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[miqStopClick]',
  standalone: false,
})
export class StopClickDirective {
  @HostListener('click', ['$event']) onClick(e) {
    e.stopPropagation();
  }
  @HostListener('keydown', ['$event']) onKeyDown(e) {
    if (e.keyCode === 32) {
      e.stopPropagation();
    }
  }
}
